module.exports = __webpack_public_path__ + "media/images/header_logo-962c40f0ffba415fe006f86296c12bd8.png";